(function () {
  if (!/\/products\//.test(window.location.pathname)) return;

  var STOCK_API = 'https://paceline-rye-production.up.railway.app/api/flash-sale/check-stock';
  var MAX_WAIT_MS = 4000;      // past this, let the add through
  var PRICE_PHASE_MS = 1500;   // when the button switches to the price message
  var BTN_SELECTOR = '[type="submit"], button.product-form__submit, .add-to-cart, [name="add"]';
  var _product = null;
  var _variantIds = {};

  function getHandle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function loadProduct(handle, cb) {
    fetch('/products/' + handle + '.json')
      .then(function (r) { return r.json(); })
      .then(function (data) { cb(data.product); })
      .catch(function () { cb(null); });
  }

  function hasTag(product, tag) {
    if (!product || !product.tags) return false;
    if (typeof product.tags === 'string') {
      return product.tags.split(',').some(function (t) { return t.trim().toLowerCase() === tag; });
    }
    if (Array.isArray(product.tags)) {
      return product.tags.some(function (t) { return t.toLowerCase() === tag; });
    }
    return false;
  }

  // The variant this form adds — read from the form itself so quick-add forms
  // for other (recommended) products aren't checked against this product
  function getFormVariantId(form) {
    var input = form.querySelector('[name="id"]');
    if (input && input.value) return input.value;
    return new URL(window.location.href).searchParams.get('variant');
  }

  // Theme buttons wrap their text in a span; fall back to the button itself
  function labelEl(btn) {
    return btn.querySelector('.single-add-to-cart-button--text') || btn;
  }

  function setLabel(btn, text) {
    if (!btn) return;
    var el = labelEl(btn);
    if (btn.dataset.pclLabel === undefined) btn.dataset.pclLabel = el.textContent;
    el.textContent = text;
  }

  function restoreLabel(btn) {
    if (!btn || btn.dataset.pclLabel === undefined) return;
    labelEl(btn).textContent = btn.dataset.pclLabel;
    delete btn.dataset.pclLabel;
  }

  function clearMessage(form) {
    var msg = form.querySelector('.pcl-stock-msg');
    if (msg) msg.remove();
    var btn = form.querySelector(BTN_SELECTOR);
    if (btn && btn.dataset.pclSoldOut) {
      delete btn.dataset.pclSoldOut;
      btn.disabled = false;
      btn.classList.remove('disabled');
      restoreLabel(btn);
    }
  }

  function soldOutMessage(data) {
    if (!data.otherOptions) return 'Just sold out';
    if (data.otherInStock) return 'This option just sold out';
    return 'Just sold out — check back soon';
  }

  function markSoldOut(form, variantId, data) {
    var btn = form.querySelector(BTN_SELECTOR);
    if (btn) {
      setLabel(btn, 'Sold out');
      btn.disabled = true;
      btn.classList.add('disabled');
      btn.dataset.pclSoldOut = '1';
    }
    var select = form.querySelector('select[name="id"]');
    if (select && variantId) {
      var opt = select.querySelector('option[value="' + variantId + '"]');
      if (opt) opt.disabled = true;
    }
    var msg = document.createElement('p');
    msg.className = 'pcl-stock-msg';
    msg.setAttribute('role', 'status');
    msg.style.cssText = 'margin:8px 0 0;font-size:14px;line-height:1.4;';
    msg.textContent = soldOutMessage(data);
    if (btn && btn.parentNode) btn.parentNode.insertBefore(msg, btn.nextSibling);
    else form.appendChild(msg);
  }

  function resubmit(form) {
    form.dataset.pclVerified = '1';
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      var btn = form.querySelector(BTN_SELECTOR);
      if (btn) btn.click();
      else form.submit();
    }
    setTimeout(function () { delete form.dataset.pclVerified; }, 200);
  }

  function interceptForm(form) {
    form.addEventListener('submit', function (e) {
      if (form.dataset.pclVerified) return;
      if (form.dataset.pclChecking) { e.preventDefault(); e.stopImmediatePropagation(); return; }

      var variantId = getFormVariantId(form);
      if (!variantId || !_variantIds[variantId]) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      clearMessage(form);

      var btn = form.querySelector(BTN_SELECTOR);
      form.dataset.pclChecking = '1';
      setLabel(btn, 'Checking stock…');
      var phase = setTimeout(function () { setLabel(btn, 'Confirming today’s price…'); }, PRICE_PHASE_MS);

      var done = false;
      function finish(data) {
        if (done) return;
        done = true;
        clearTimeout(phase);
        clearTimeout(timer);
        delete form.dataset.pclChecking;
        restoreLabel(btn);
        if (data && data.inStock === false) markSoldOut(form, variantId, data);
        else resubmit(form);
      }
      // Never hold the shopper up for long: no answer in time → add anyway
      var timer = setTimeout(function () { finish(null); }, MAX_WAIT_MS);

      fetch(STOCK_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ productId: String(_product.id), variantId: String(variantId) }),
      })
        .then(function (r) { return r.json(); })
        .then(finish)
        .catch(function () { finish(null); });
    }, true);
  }

  var handle = getHandle();
  if (!handle) return;

  loadProduct(handle, function (product) {
    // Henry-sourced products carry one of these tags; the server checks source_url
    if (!product || !(hasTag(product, 'flash-sale') || hasTag(product, 'henry-labs'))) return;
    _product = product;
    (product.variants || []).forEach(function (v) { _variantIds[String(v.id)] = true; });

    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      interceptForm(forms[i]);
    }

    // Picking another option clears our sold-out state before the theme
    // updates the button (the picker and the button can sit in different forms)
    document.addEventListener('change', function () {
      for (var j = 0; j < forms.length; j++) clearMessage(forms[j]);
    }, true);
  });
})();
